import { http } from '@/utils/http'
export const ENTITYBASE = window.$envUtils('VUE_APP_ENTITY_SERVICE')

export const querySysEntityList = (params) => {
  return http.get(`${ENTITYBASE}/entity/sysEntity/list`, { params })
}

export const disableOrEnableSysEntity = (params) => {
  return http.get(`${ENTITYBASE}/entity//sysEntity`, { params })
}

export const allDisableOrEnableSysEntity = (params) => {
  return http.get(`${ENTITYBASE}/entity/sysEntity/allSwitch`, { params })
}

export const predictEntity = (params) => {
  return http.get(`${ENTITYBASE}/entity/sysEntity/predictEntity`, { params })
}
